// Forms config files

import { claimsInfoFields } from './forms/claims-info';
import { claimantRepsFields } from './forms/claimant-reps';
import { vehiclesFields } from './forms/vehicles';
import { reserveFields } from './forms/reserve';
import { vehicleDamageFields } from './forms/vehicle-damage';
import { lossOfUseFields } from './forms/loss-of-use';
import { paymentPackFields } from './forms/payment-pack';
import { strategiesFields } from './forms/strategy';
import { offersPaymentsFields } from './forms/offers-payments';
import { litigationInfoFields } from './forms/litigation-info';
import { claimsSummaryFields } from './forms/claims-summary';
import { isdFields } from './forms/isd';

export const fieldsPlaceholders = {
    text: 'Enter text',
    date: 'dd/mm/yyyy',
    dateRange: 'dd/mm/yyyy - dd/mm/yyyy',
    boolean: 'Select option',
    dropdown: 'Select option',
    integer: 'Enter number',
    float: 'Enter number',
    link: 'Not provided'
};

export const caseFormConfig = {
    tabs: [
        {
            key: 'ocr',
            name: 'OCR',
            fields: [],
            highlight: true,
            advanced_view_only: false
        },
        {
            key: 'claim_summary',
            name: 'Claims Summary',
            fields: claimsSummaryFields,
            highlight: true,
            advanced_view_only: false
        },
        {
            key: 'documents',
            name: 'Documents',
            fields: [],
            highlight: true,
            advanced_view_only: false
        },
        {
            key: 'notes',
            name: 'Claim Notes',
            fields: [],
            highlight: true,
            advanced_view_only: false
        },
        {
            key: 'audits',
            name: 'Audit',
            fields: [],
            highlight: true,
            advanced_view_only: false
        },
        {
            key: 'rulesets',
            name: 'Rulesets',
            fields: [],
            highlight: true,
            advanced_view_only: false
        },
        {
            key: 'outcomes',
            name: 'Outcome Advice',
            fields: [],
            highlight: true,
            important: true,
            advanced_view_only: false
        },
        {
            key: 'isd',
            name: 'Initial Strategy Document',
            fields: isdFields,
            highlight: true,
            advanced_view_only: false
        },
        {
            key: 'claim_info',
            name: 'Claims Info',
            fields: claimsInfoFields,
            advanced_view_only: false
        },
        {
            key: 'claimant_reps',
            name: 'Claimant Reps',
            fields: claimantRepsFields,
            advanced_view_only: true
        },
        {
            key: 'vehicles',
            name: 'Vehicles',
            fields: vehiclesFields,
            advanced_view_only: true
        },
        {
            key: 'reserve',
            name: 'Reserve',
            fields: reserveFields,
            advanced_view_only: true
        },
        {
            key: 'vehicle_damage',
            name: 'Vehicle Damage',
            fields: vehicleDamageFields,
            advanced_view_only: true
        },
        {
            key: 'loss_of_use',
            name: 'Loss Of Use',
            fields: lossOfUseFields,
            advanced_view_only: false
        },
        {
            key: 'payment_pack',
            name: 'Payment Pack',
            fields: paymentPackFields,
            advanced_view_only: true
        },
        {
            key: 'strategy',
            name: 'Strategy',
            fields: strategiesFields,
            advanced_view_only: true
        },
        {
            key: 'offers_payments',
            name: 'Offers & Payments',
            fields: offersPaymentsFields,
            advanced_view_only: false
        },
        {
            key: 'litigation',
            name: 'Litigation',
            fields: litigationInfoFields,
            advanced_view_only: true
        },
        // {
        //     key: 'activity_schedule',
        //     name: 'Activity Schedule',
        //     fields: []
        // }
    ]
};

export const caseCustomTabs = ['claim_summary', 'notes', 'documents', 'audits', 'rulesets', 'outcomes', 'isd', 'ocr'];
